import React from "react";
import Section from "./section";

export default function MultiStopBookPage() {
  return <Section />;
}
